import { SHIFT_STATUSES } from '@/modules/shift-and-reports/constants/shiftStatuses'

const DEFAULT_ERROR_START_TEXT = 'Произошла ошибка при отправке запроса.'

export default {
    currentShiftStatus: state => state.currentShift?.status ?? null,

    isShiftOpen: state => state.currentShift?.status === SHIFT_STATUSES.OPEN,

    getErrorModalMessage: state => {
        const end = "Обратитесь в техподдержку"

        return `${state.isRKeeperHasError && !!state.rKeeperErrorText ? state.rKeeperErrorText : DEFAULT_ERROR_START_TEXT}\n${end}`
    }
}